import { render, staticRenderFns } from "./EmployeePassport.vue?vue&type=template&id=f6c07570&"
import script from "./EmployeePassport.vue?vue&type=script&lang=js&"
export * from "./EmployeePassport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports